import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

import { Hit as CatalogHit } from '../../../catalog/results/Hit';
import { Hit as DownloadsHit } from '../../../downloads/results/Hit';
import { ApplicationServiceHit, FaqHit, OtherHit } from './Overview';

export default function Hit({ hit, results, additionalData }: componentTypes.HitProps) {
  const { type } = hit;

  return (
    (type.slice(2) === 'Products' && (
      <CatalogHit results={results} hit={hit} additionalData={[]} key={hit.objectID} />
    ))
    || (type.slice(2) === 'Applications' && (
      <ApplicationServiceHit results={results} hit={hit} additionalData={[]} key={hit.objectID} />
    ))
    || (type.slice(2) === 'Services' && (
      <ApplicationServiceHit results={results} hit={hit} additionalData={[]} key={hit.objectID} />
    ))
    || (type.slice(2) === 'Downloads' && (
      <DownloadsHit
        results={results}
        hit={hit}
        additionalData={additionalData}
        key={hit.objectID}
      />
    ))
    || (type.slice(2) === 'FAQ' && (
      <FaqHit
        results={results}
        hit={hit}
        additionalData={[]}
        key={hit.objectID}
      />
    ))
    || (type.slice(2) === 'Other' && (
      <OtherHit results={results} hit={hit} additionalData={[]} key={hit.objectID} />
    ))
  );
}
